import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import ProgressButton from '../../../../../components/Form/ProgressButton'
import PropTypes from 'prop-types'

function ArchiveButton({
  updateItemAction,
  updatedItemSelector,
  updateItemErrorSelector,
  updateItemIsLoadingSelector,
  clearUpdateAction,
  dataWaitingForDelete,
  handleCloseDeleteModal,
  wrapperClassName
}) {
  // this state is used for clear understanding when exactly archive update is happening
  // because we have one update reducer for many cases: status update, edit form, etc.
  const [isArchiveRunning, setIsArchiveRunning] = useState(false)

  const dispatch = useDispatch()
  const { t } = useTranslation()

  const updateItemError = useSelector(updateItemErrorSelector)
  const { wasUpdated } = useSelector(updatedItemSelector)
  const updateItemIsLoading = useSelector(updateItemIsLoadingSelector)

  const handleArchive = useCallback(() => {
    const { item, platform, account, campaignObjective } = dataWaitingForDelete

    setIsArchiveRunning(true)

    dispatch(
      updateItemAction(
        {
          account,
          status: 'archived',
          campaign_objective: campaignObjective
        },
        item.id,
        platform
      )
    )
  }, [dataWaitingForDelete, dispatch, updateItemAction])

  const clearErrorHandler = useCallback(() => {
    clearUpdateAction && dispatch(clearUpdateAction())
  }, [dispatch, clearUpdateAction])

  useEffect(() => {
    if (isArchiveRunning && (wasUpdated || updateItemError)) {
      setIsArchiveRunning(false)

      handleCloseDeleteModal()
      clearErrorHandler()
    }
  }, [wasUpdated, updateItemError, clearErrorHandler, handleCloseDeleteModal, isArchiveRunning])

  return (
    <ProgressButton
      onClick={handleArchive}
      formError={isArchiveRunning ? updateItemError : {}}
      isFormLoading={updateItemIsLoading}
      successSubmit={wasUpdated}
      clearHandler={clearErrorHandler}
      wrapperClassName={wrapperClassName}
    >
      {t('Archive')}
    </ProgressButton>
  )
}

ArchiveButton.propTypes = {
  updateItemAction: PropTypes.func,
  updatedItemSelector: PropTypes.func,
  updateItemErrorSelector: PropTypes.func,
  updateItemIsLoadingSelector: PropTypes.func,
  clearUpdateAction: PropTypes.func,
  dataWaitingForDelete: PropTypes.object,
  handleCloseDeleteModal: PropTypes.func,
  wrapperClassName: PropTypes.string
}

export default ArchiveButton
